export default __webpack_public_path__ + "static/media/activities-icon-tool.9fd9af36.svg";